import React from 'react';

export default function ChatBubbleIcon({
  width = 21,
  height = 20,
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_4150_10143)">
        <path
          d="M9.81027 0.0284844C16.0807 -0.419576 21.0381 4.49224 20.6826 10.7401C20.4117 15.5049 16.2333 19.6693 11.4565 19.9407C8.13253 20.1296 4.63136 19.7937 1.28871 19.9407C1.00199 19.9332 0.735093 19.6804 0.701294 19.3956V9.21343C1.03288 4.45388 5.01307 0.370777 9.81027 0.0284844ZM2.09756 18.5472L11.1949 18.5489C18.9927 18.0572 22.2374 8.21387 16.0521 3.2608C10.6226 -1.08731 2.5253 2.60178 2.09582 9.43136L2.09756 18.5466V18.5472Z"
          fill="currentColor"
        />
        <path
          d="M5.92499 10.2049L14.4203 10.195C15.2449 10.2426 15.3772 11.4125 14.5526 11.5874H5.91333C5.12254 11.4113 5.15168 10.3838 5.92499 10.2049Z"
          fill="currentColor"
        />
        <path
          d="M14.907 6.68603C15.3143 7.07133 15.0719 7.82449 14.509 7.88958L5.95827 7.88842C5.13018 7.7565 5.12843 6.62908 5.95827 6.49658L14.6488 6.52971C14.7269 6.58143 14.8411 6.62327 14.907 6.68603Z"
          fill="currentColor"
        />
        <path
          d="M11.1995 14.1247C11.6255 14.5721 11.3196 15.2782 10.7135 15.3276L5.96234 15.3235C5.1663 15.1736 5.0987 14.1223 5.91397 13.9346C7.47865 14.0386 9.21467 13.7998 10.7584 13.934C10.9245 13.9486 11.0824 14.002 11.1995 14.1247Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4150_10143">
          <rect width="20" height="20" fill="white" transform="translate(0.700073)" />
        </clipPath>
      </defs>
    </svg>
  );
}
